export default __webpack_public_path__ + "static/media/circle.a538beda.svg";